import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-store-receipt",
  "use": "icon-soc-store-receipt-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-store-receipt\">\n<g fill=\"currentColor\">\n<rect x=\"220\" y=\"180\" width=\"584\" height=\"720\" rx=\"28\" />\n<rect x=\"300\" y=\"260\" width=\"424\" height=\"48\" fill=\"#fff\" />\n<rect x=\"300\" y=\"360\" width=\"320\" height=\"40\" fill=\"#fff\" />\n<rect x=\"300\" y=\"440\" width=\"280\" height=\"40\" fill=\"#fff\" />\n<circle cx=\"720\" cy=\"760\" r=\"88\" fill=\"#fff\" />\n<circle cx=\"720\" cy=\"760\" r=\"40\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-store-receipt.svg
// module id = Ox4J
// module chunks = 534